module.exports = __webpack_public_path__ + "assets/pdf/BN03-en-food-security.87e467d2.pdf";